import { useTranslation } from "react-i18next"
import styled from "styled-components"

import { Choice } from "~/components/Choice"
import { GroundMount, RoofMount } from "~/components/Icons"
import type { IPart } from "~/containers/Proposal/Setup/Form/setup-steps-types"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { SystemType } from "~/graphql/client"

import { SetupMenuFormFooter } from "../SetupMenuFooter"

export enum MountType {
  ROOF_MOUNT = `roofMount`,
  GROUND_MOUNT = `groundMount`,
  BOTH = `both`,
}

const MountChoice = styled(Choice)`
  min-height: 225px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: space-evenly;
  text-align: center;
  padding: var(--space-xs);
  border: 2px solid var(--blue);
  border-radius: 15px;
  gap: 20px;
  cursor: pointer;
  user-select: none;
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--blue);
  }
  &,
  * {
    transition: all 0.1s ease;
  }
  input {
    display: none;
  }
  h1 {
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  h1,
  p {
    position: relative;
    z-index: var(--z-styled-choice-text);
  }
  p {
    font-size: var(--step--2);
    display: none;
  }
  .bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.3;
  }
  input[type="radio" i]:checked ~ {
    .bg {
      opacity: 1;
      background: var(--blue);
      border-radius: 15px;
      box-shadow: 0px 0px 10px var(--blue);
      box-shadow: rgb(0, 112, 244, 0.25) 0px 10px 20px;
    }
    .image {
      color: var(--white);
    }
    * {
      transform: scale(1.05);
    }
    h1,
    p {
      color: var(--white);
    }
  }
  &:active {
    transform: scale(0.98);
    .bg {
      box-shadow: none;
    }
  }
`

const MountSelection: IPart[`form`] = () => {
  const proposal = useProposalContext()
  const { t } = useTranslation()

  return (
    <form id="mountSelection">
      <section>
        <span className="flex flex-col justify-between items-start gap-5 min-h-[55px] relative min-[750px]:flex-row min-[750px]:gap-y-0 [&>div]:w-full [&>div]:overflow-hidden">
          <MountChoice
            options={[
              {
                key: SystemType.roof_mount,
                label: t(MountType.ROOF_MOUNT),
                imageUrl: <RoofMount />,
              },
              {
                key: SystemType.ground_mount,
                label: t(MountType.GROUND_MOUNT),
                imageUrl: <GroundMount />,
              },
              {
                key: SystemType.both,
                label: t(MountType.BOTH),
                imageUrl: <RoofMount />,
              },
            ]}
            value={proposal.local.systemType ?? `roof_mount`}
            setValue={(value) => {
              proposal.changeLocal({ systemType: value as SystemType })
            }}
          />
        </span>
      </section>
      <SetupMenuFormFooter
        entitiesToUpdate={[proposal]}
        isLoading={proposal.isLoading}
      />
    </form>
  )
}

export default MountSelection
